module.exports = __webpack_public_path__ + "img/carters_logo@2x.3ee74b5c.png";